import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toPhone, toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedClientesData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`clientes/grid?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllClientesData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`clientes/grid?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.nome}"`,
    `"${data.telefone != null ? toPhone(data.telefone) : ''}"`,
    `"${data.email ?? ''}"`,
    `"${toDate(data.dataHoraCriacao)}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCriacaoInicial: toDateFromPtBr(options.creationInitialDate),
  dataCriacaoFinal: toDateFromPtBr(options.creationEndDate),
});
